<template>
  <div class="project-asslysis-root">
    <!--日期选择-->
    <div style="margin-bottom: 20px">
      <span>选择日期:&nbsp;&nbsp;</span>
      <el-date-picker
        size="large"
        style="width: 300px"
        v-model="dateRange"
        @change="handelDateChange"
        type="daterange"
        align="left"
        unlink-panels
        :clearable="false"
        range-separator="~"
        :shortcuts="shortcuts"
      >
      </el-date-picker>
    </div>
    <div class="analysiscss" v-loading="isLoading">
      <el-row style="height: 100%">
        <el-col :span="14" style="height: 100%; position: relative">
          <div class="myChartcss" id="myChart"></div>
          <div v-show="tableData.length === 0" class="no-data-tip">
            暂无数据
          </div>
        </el-col>
        <el-col
          :span="10"
          style="height: 100%; overflow-y: auto; padding: 20px 20px 20px 0"
        >
          <el-table class="tablecss" :data="tableData"
                    row-key="project_name"
                    :tree-props="{ children: 'applist'}"
          >
            <el-table-column prop="projectid" label="项目ID"> </el-table-column>
            <el-table-column prop="project_name" label="名称" width="200"></el-table-column>
            <el-table-column prop="percent" label="比例">
              <template #default="scope">
                  <span style="margin-left: 10px">{{ formatePercent(scope.row.percent) }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="capacity" label="空间大小">
              <template #default="scope">
                <span style="margin-left: 10px">{{ formateCapacity(scope.row.total_size) }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="applist" label="应用数量">
              <template #default="scope">
                <span style="margin-left: 10px">{{ scope.row.applist?.length}}</span>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script setup>
import { getCurrentInstance, onMounted, onBeforeUnmount, ref } from "vue";
import { apiGetAnalysisData } from "@/Api/AppApi";
import * as echarts from "echarts";

const { appContext } = getCurrentInstance();
const $moment = appContext.config.globalProperties.$moment;
const $message = appContext.config.globalProperties.$message;

const shortcuts = [
  {
    text: "本月",
    value() {
      const end = $moment().format("YYYY-MM-DD");
      const start = $moment().startOf("month").format("YYYY-MM-DD");
      return [start, end];
    },
  },
  {
    text: "上月",
    value() {
      const start = $moment()
        .startOf("month")
        .subtract(1, "month")
        .format("YYYY-MM-DD");
      const end = $moment()
        .startOf("month")
        .subtract(1, "days")
        .format("YYYY-MM-DD");
      return [start, end];
    },
  },
];

const dateRange = ref([]);
onMounted(() => {
  dateRange.value = [
    $moment().startOf("month").format("YYYY-MM-DD"),
    $moment().format("YYYY-MM-DD"),
  ];

  getData();
});

onBeforeUnmount(() => {
  if (myChart) {
    myChart.dispose();
    myChart = null;
    window.onresize = undefined;
  }
});

const isLoading = ref(false);
const tableData = ref([]);
async function getData() {
  const startTime = $moment(dateRange.value[0]).startOf("day").unix();
  const endTime = $moment(dateRange.value[1]).endOf("day").unix();
  isLoading.value = true;
  const res = await apiGetAnalysisData(startTime, endTime);
  isLoading.value = false;
  if (res.code === 0) {
    tableData.value = res.data;
    updateChart(res.data);
  } else {
    $message.error(res.message);
  }
}

let myChart = null;
function updateChart(data) {
  let serieData = [];
  for (const item of data) {
    item.capacity = getFileSize(item.total_size);
    item.percent = (item.percent * 100).toFixed(2) + "%";
    serieData.push({
      projectid: item.projectid,
      name: item.project_name,
      value: item.total_size,
      capacity: item.capacity,
      percent: item.percent,
    });
  }

  const option = {
    title: {
      left: "center",
    },
    tooltip: {
      trigger: "item",
      padding: [10, 10, 10, 10],
      formatter: function (params) {
        return (
          "项目ID：" +
          params.data.projectid +
          "</br>" +
          "名称：" +
          params.data.name +
          "</br>" +
          "比例：" +
          params.data.percent +
          "</br>" +
          "空间大小：" +
          params.data.capacity
        );
      },
    },
    series: [
      {
        type: "pie",
        radius: "55%",
        center: ["50%", "50%"],
        data: serieData,
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: "rgba(0, 0, 0, 0.5)",
          },
        },
      },
    ],
  };

  if (myChart === null) {
    myChart = echarts.init(document.getElementById("myChart"));
    window.onresize = myChart.resize;
  }
  myChart.clear();
  myChart.setOption(option);
}

const mags = "BKMGTPEZY";
function getFileSize(bytes, precision = 2) {
  const magnitude = Math.min(
    (Math.log(bytes) / Math.log(1024)) | 0,
    mags.length - 1
  );
  const result = bytes / Math.pow(1024, magnitude);
  const suffix = mags[magnitude].trim();
  return result.toFixed(precision) + suffix;
}

function handelDateChange() {
  getData();
}


function formatePercent(_val){
  if(_val.toString().indexOf("%") > -1){
    return _val;
  }else{
    return  (_val * 100).toFixed(2) + "%";
  }
}
function formateCapacity(_val){
  return  getFileSize(_val);
}

</script>

<style lang="scss" scoped>
.project-asslysis-root {
  padding: 20px;
}
.analysiscss {
  background-color: #fff;
  width: 100%;
  height: calc(100vh - 150px);
}
.myChartcss {
  width: 100%;
  height: 100%;
}
.tablecss {
  width: 100%;
}

.no-data-tip {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #909399;
}
</style>
